import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVMultiselect } from "../../shared/JVMultiselect";

export interface IFilter {
    contact?: IDropdown;
    contact_ID?: number;
    status_ID?: number;
    source_ID?: number[];
    countryId?: number;
    stateId?: number;
    cityId?: number;
    assigned_To?: number;
    fromDate?: Date;
    toDate?: Date;
    createdBy?: number[];
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [createdByUsers, setCreatedByUsers] = useState<IDropdown[]>();

    const isLeadGenerated = [{id: 0, name: "--Select--"},{ id: 1, name: "Yes" }, { id: 2, name: "No" }]

    const { control, handleSubmit, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filter,
        shouldFocusError: false
    });

    const countryId = watch("countryId");
    const stateId = watch("stateId");

    useEffect(() => {
        loadUsers();
        loadStatus();
        loadCreatedByUsers();
        loadSources();
    }, []);



    useEffect(() => {
        if (countryId) {
            setValue("stateId", undefined);
            setValue("cityId", undefined);
            setStates([]);
            setCities([]);
            loadStates(countryId);
        }
    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            setValue("cityId", undefined);
            setCities([]);
            loadCities(stateId);
        }
    }, [stateId]);



    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            const statusList = await response.json();
            setStatus([{ id: undefined, name: "--Select Status--" }, ...statusList]);
        }
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setSources([...sourceList]);
        }
    }

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setUsers([{ id: undefined, name: "--Select--" }, ...userList]);
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            const stateList = await response.json();
            setStates([{ id: undefined, name: "--Select State--" }, ...stateList]);
        }
    }

    const loadCities = async (stateId: number) => {
        const response = await Fetch(`city/dropdown/${stateId}`, "GET", null, null, null);
        if (response) {
            const cityList = await response.json();
            setCities([{ id: undefined, name: "--Select City--" }, ...cityList]);
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }


    const loadCreatedByUsers = async () => {
        const response = await Fetch("user/createdbydropdown", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setCreatedByUsers([...userList]);
        }
    };
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        if (data.contact) {
            data.contact_ID = data.contact.id;
        }
        searchToDB(data);
    }

    const Clear = () => {
        reset({});
        setStates([]);
        setCities([]);
    }

    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdownInput column={3} completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" />
                    {/* <JVDropdown column={4} label="Country" control={control} options={countries} optionLabel="name" optionValue="id" name="countryId" placeholder="Select Country" />
                    <JVDropdown column={4} label="State" control={control} options={states} optionLabel="name" optionValue="id" name="stateId" placeholder="Select State" />
                    <JVDropdown column={4} label="City" control={control} options={cities} optionLabel="name" optionValue="id" name="cityId" placeholder="Select City" /> */}
                    <JVDate column={3} label="From Date" control={control} name="fromDate" />
                    <JVDate column={3} label="To Date" control={control} name="toDate" />
                    <JVMultiselect column={3} filter label="Sources" options={sources} optionLabel="source_Name" optionValue="id" value={watch("source_ID") || []} placeholder="Select Sources" onChange={(ids: number[]) => { setValue("source_ID", ids); }} />
                    <JVMultiselect column={3} filter label="Created By" options={createdByUsers} optionLabel="name" optionValue="id" value={watch("createdBy") || []} placeholder="Select Users" onChange={(ids: number[]) => { setValue("createdBy", ids); }} />
                    <JVDropdown column={3} label="Lead Generated" control={control} options={isLeadGenerated} optionLabel="name" optionValue="id" name="isLeadGenerated" placeholder="Select" />
                    <div className="col-12 md:col-3 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button style={{ width: '100px', height: '34px' }} loading={props.loading} label="SEARCH" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px', height: '34px' }} label="CLEAR" onClick={Clear} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </AccordionTab>
        </Accordion>
    );
}
